export const STRUCTUREPREVIEWBYID_REQUEST = 'STRUCTUREPREVIEWBYID_REQUEST';
export const STRUCTUREPREVIEWBYID_SUCCESS = 'STRUCTUREPREVIEWBYID_SUCCESS';
export const STRUCTUREPREVIEWBYID_FAIL = 'STRUCTUREPREVIEWBYID_FAIL';
